<template>
    <v-chip class="px-2 text-truncate job-type-chip" color="disabled" size="small" variant="flat">
        {{ typeName }}
    </v-chip>
</template>

<script>
export default {
    name: 'JobTypeChip',
    props: {
        typeId: Number,
        typeName: String,
    },
    components: {},

    data() {
        return {

        };
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped>
.job-type-chip {
    border-radius: 4px;
    color: #fff;
    font-weight: 700;
}
</style>